import React from 'react';
import { useState } from 'preact/hooks';
import Markdown from 'markdown-to-jsx';
import { useTranslation } from 'react-i18next';
import Modal from '../../../tailwind_common/Modal/Modal.Lazy.Wrapped';
import { THEME } from '../../../clearstep/util/Theme';
import { hasWidgetUrlPath } from '../../../clearstep/util/AppHelpers';
import { logEvent, MessageType } from '../../../../util/EventLog';
import { SuccessIcon } from '../../../svg/SuccessIcon';
import { submitMessageFeedback } from '../../../../api/Feedback';
import Button from '../../../tailwind_common/Button';
import Textarea from '../../../tailwind_common/Textarea';
import { renderLink } from '../../../clearstep/util/MarkdownHelpers';
import { useTranslationService } from '../../../../util/i18n/TranslationServiceProvider';
import { WIDGET_NAMESPACE } from '../../../../util/i18n/constants';
export var WidgetFeedbackModal = function (props) {
    var _a;
    var _b = useState(false), isSubmitted = _b[0], setIsSubmitted = _b[1];
    var _c = useState(''), message = _c[0], setMessage = _c[1];
    var tService = useTranslationService().tService;
    var t = useTranslation().t;
    var handleClose = function () {
        props.setIsFeedbackOpen(false);
        logEvent(MessageType.BUTTON_CLICK, {
            name: 'Feedback widget',
        }, { partner: THEME.partner });
    };
    var onSubmit = function () {
        if (!message) {
            return;
        }
        setIsSubmitted(true);
        setTimeout(function () {
            props.setIsFeedbackOpen(false);
        }, 2000);
        submitMessageFeedback({
            feedback_type: hasWidgetUrlPath() ? '{widget}' : '',
            message: message,
            message_len: 0,
            conversation_id: props.conversationId !== 0 ? props.conversationId.toString() : '',
            partner: THEME.partnerHostName,
        });
    };
    return (React.createElement(Modal, { className: "mobile:max-h-full", isOpen: props.isOpen, title: t('widget.feedbackModal.title', 'Help Us Improve'), onClose: handleClose, disableCloseOnClickOutside: true, hideCloseButton: true },
        !isSubmitted && (React.createElement(React.Fragment, null,
            React.createElement("p", { className: "mb-4 font-normal" }, t('widget.feedbackModal.question.text', 'How can we improve our chat experience?')),
            React.createElement(Textarea, { containerClassName: "mb-3 flex flex-col", textareaClassName: "basis-52", onChange: function (e) { return setMessage(e.target.value); }, value: message, placeholder: t('widget.feedbackModal.question.responsePlaceholder', 'Enter your response'), id: "feedbackTextarea" }),
            ((_a = THEME.widgetCustomizations) === null || _a === void 0 ? void 0 : _a.feedbackModalUnderInputText) && (React.createElement("div", { className: "mb-6 text-sm font-medium font-normal text-gray-600" },
                React.createElement(Markdown, { options: {
                        overrides: {
                            a: function (innerProps) {
                                return renderLink(innerProps.href, innerProps.children, MessageType.LINK_CLICK, 'text-gray-900 no-underline font-medium');
                            },
                        },
                    } }, tService(THEME.widgetCustomizations.feedbackModalUnderInputText, {
                    ns: WIDGET_NAMESPACE,
                })))),
            React.createElement("div", { className: "mt-auto flex justify-end gap-4 mobile:flex-col-reverse" },
                React.createElement(Button, { isText: true, onClick: handleClose }, t('common.cancelCta', 'Cancel')),
                React.createElement(Button, { onClick: onSubmit, disabled: !message }, t('common.submitCta', 'Submit'))))),
        isSubmitted && (React.createElement("div", { className: "flex flex-1 basis-80 flex-col items-center justify-center" },
            React.createElement(SuccessIcon, { className: "mb-6" }),
            React.createElement("h2", { role: "alert", className: "text-lg" }, t('widget.feedbackModal.successMessage', 'Your response has been recorded. Thank you!'))))));
};
export default WidgetFeedbackModal;
